"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryableErrors = exports.throwError = void 0;
const bad_gateway_1 = require("./bad-gateway");
const bad_request_1 = require("./bad-request");
const forbidden_1 = require("./forbidden");
const gateway_timeout_1 = require("./gateway-timeout");
const internal_error_1 = require("./internal-error");
const network_error_1 = require("./network-error");
const not_enough_storage_1 = require("./not-enough-storage");
const not_found_1 = require("./not-found");
const service_unavailable_1 = require("./service-unavailable");
const too_many_requests_1 = require("./too-many-requests");
const unauthorized_1 = require("./unauthorized");
const throwError = (status, message, error) => {
    switch (status) {
        case 400:
            throw new bad_request_1.BadRequest(message, error);
        case 401:
            throw new unauthorized_1.Unauthorized(message, error);
        case 402:
            throw new not_enough_storage_1.NotEnoughStorage(message, error);
        case 403:
            throw new forbidden_1.Forbidden(message, error);
        case 404:
            throw new not_found_1.NotFound(message, error);
        case 429:
            throw new too_many_requests_1.TooManyRequests(message, error);
        case 502:
            throw new bad_gateway_1.BadGateway(message, error);
        case 503:
            throw new service_unavailable_1.ServiceUnavailable(message, error);
        case 504:
            throw new gateway_timeout_1.GatewayTimeout(message, error);
        default:
            if (error && error['code'] && (error['code'] === 'ENOTFOUND' || error['code'] === 'ECONNRESET' || error['code'] === 'ETIMEDOUT' || error['code'] === 'ECONNREFUSED' || error['code'] === 'ESOCKETTIMEOUT' || error['code'] === 'socket hang-up')) {
                throw new network_error_1.NetworkError(error['code'], error);
            }
            throw new internal_error_1.InternalError("Internal error. Please try again or contact Akord support.", error);
    }
};
exports.throwError = throwError;
exports.retryableErrors = [network_error_1.NetworkError, bad_gateway_1.BadGateway, service_unavailable_1.ServiceUnavailable, gateway_timeout_1.GatewayTimeout];
